<button
    class="button"
    aria-haspopup="listbox"
    [attr.aria-expanded]="expanded"
    [ngClass]="{ mark: expanded }"
    (click)="expand(!expanded)"
>
    <app-filter-count
        *ngIf="facetGroup?.values | activeFacetsCount as count"
        [count]="count"
        @fadeIn
    ></app-filter-count>
    {{ facetGroup?.text }}
    <span class="arrow-icon">
        <app-svg-icon iconName="chevron_down"></app-svg-icon>
    </span>
</button>
<ul class="list" role="listbox" *ngIf="expanded" @transform>
    <li class="list-item" role="option" *ngFor="let facet of facetGroup?.values; trackBy: trackFacetFn">
        <label class="checkbox-wrapper">
            <input
                class="kk-checkbox kk-visuallyhidden"
                type="checkbox"
                [(ngModel)]="facet.selected"
                (change)="onChange(facet)"
            />
            <span class="kk-checkbox__element checkbox-element">
                <span class="kk-checkbox__icon">
                    <app-svg-icon iconName="tick"></app-svg-icon>
                </span>
            </span>
            <span class="text" [ngClass]="{ 'text-bold': facet.selected }" *ngIf="facet.key">
                {{
                    facet.key
                        | replaceKey
                            : {
                                  '0': 'filter.facetText.no' | translateSafe,
                                  '1': 'filter.facetText.yes' | translateSafe
                              }
                }}
                <span class="facet-count" *ngIf="facet.count"> ({{ facet.count }}) </span>
            </span>
        </label>
    </li>
</ul>
